export default fnToRunOnReady => {
    //if using the hot reloader wait for all css and js to be added before saying document is ready;
    //this is here so that the carousel in the VIP page works, since it relies on css size and position
    //then it's important the css is loaded before js can start to do calculations
    if (process && process.env && process.env.NODE_ENV !== 'production') {
        if (document.readyState === 'complete') {
            fnToRunOnReady();
        } else {
            window.onload = () => {
                fnToRunOnReady();
            };
        }
        return;
    }
    if (
        document.attachEvent
            ? document.readyState === 'complete'
            : document.readyState !== 'loading'
    ) {
        fnToRunOnReady();
    } else {
        document.addEventListener('DOMContentLoaded', fnToRunOnReady);
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/on-ready.js